import { yellow } from '@mui/material/colors';

import { createThemePalette, HTML } from './helper';

const SLATE = '#2F4150';
const TEAL = '#3BA99C';
const PAPER = '#F6F4EE';
const PAPER_OFF = '#ECE9E0';
const AMBER = '#EBB626';
const DATA_1 = '#3D5A80';
const DATA_2 = '#C45A45';
const AMBER_WARNING = '#F2C231';
const LIME = '#A4E058';
const LINE = '#E4E2DA';
const INK_PRIMARY = '#1F2A35';
const INK_SECONDARY = '#3A4654';
const INK_DISABLED = '#7A8590';
const WHITE = '#FFFFFF';

const heritagePalette = createThemePalette({
  primary: SLATE,
  secondary: TEAL,
  divider: LINE,
  error: DATA_2,
  success: LIME,
  warning: AMBER_WARNING,
  text: {
    primary: INK_PRIMARY,
    disabled: INK_DISABLED,
    secondary: INK_SECONDARY,
  },
  background: { default: WHITE, off_paper: PAPER_OFF, paper: PAPER },
});

export { heritagePalette };
